var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"viewContainer pa-0"},[_c('heroSection'),_c('solutionSection'),_c('whyUsSection'),_c('videoSection'),_c('digitToPhysicSection'),_c('ourBeaconsSection'),_c('maBaliseSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }